import React from 'react';
import { useTranslation } from 'react-i18next';
import Div from '../Div';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import './footer.scss';
import { localizePath } from '../../helper/localizedPath';

export default function Footer({ copyrightText, logoSrc, logoAlt, text }) {
  const { t, i18n } = useTranslation();
  const language = i18n.language === 'en' ? 'en' : 'cs';

  const copyrightLinks = [
    {
      title: t('footer.termsOfUse'),
      href: '/',
    },
    {
      title: t('footer.privacyPolicy'),
      href: '/',
    },
  ];

  const serviceMenu = [
    {
      title: t('footer.recording'),
      href: localizePath('/sluzby/nahravani', language),
    },
    {
      title: t('footer.mixMastering'),
      href: localizePath('/sluzby/mix_mastering', language),
    },
    {
      title: t('footer.studioRental'),
      href: localizePath('/sluzby/pronajem_studia', language),
    },
    {
      title: t('footer.accommodation'),
      href: localizePath('/sluzby/ubytovani', language),
    },
    {
      title: t('footer.podcastRecording'),
      href: localizePath('/sluzby/podcast', language),
    },
  ];

  return (
    <footer className="cs-fooer">
      <Div className="cs-fooer_main">
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <TextWidget
                  logoSrc="/images/stablerecords/SR-white-logo.webp"
                  logoAlt="Logo"
                  text=""
                  width={300}
                  height={80}
                />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <MenuWidget menuItems={serviceMenu} menuHeading={t('footer.services')} />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <ContactInfoWidget title={t('footer.contactUs')} />
              </Div>
            </Div>
            <Div className="col-lg-3 col-sm-6">
              <Div className="cs-footer_item">
                <Newsletter
                  title={t('footer.newsletterTitle')}
                  subtitle={t('footer.newsletterSubtitle')}
                  placeholder="example@gmail.com"
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-bottom_footer_left">
            <Div className="cs-copyright">{t('footer.copyright')}</Div>
          </Div>
          <Div className="cs-bottom_footer_right">
            <MenuWidget menuItems={copyrightLinks} variant=" cs-style2" />
          </Div>
        </Div>
      </Div>
    </footer>
  );
}